import React, { Component } from 'react'
import ItemList from './ItemList'
import { Button, Icon } from 'react-materialize'

class Shop extends Component {
  render() {
    return (
      <div style={{ margin: '30px 0' }}>
        <h4>Login to continue</h4>
        <ItemList/>

        <Button waves="light">
          <Icon>cancel</Icon>
        </Button>

        <span style={{ padding: '0 10px' }}></span>

        <Button waves="light">
          <Icon>update</Icon>
        </Button>
      </div>
    )
  }
}

export default Shop